import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {UserSetting} from '../models/userLight';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

  public settingsLoaded: Subject<boolean> = new Subject<boolean>();
  public userSettings: Array<UserSetting>;

  constructor(public http: HttpClient, private auth: AuthService, private toast: ToastrService) {
  }

  public FetchUserSettings() {
    return this.http.get<Array<UserSetting>>(environment.baseURl + `/api/user/settings`).subscribe((dta: Array<UserSetting>) => {

        this.userSettings = dta;
        this.settingsLoaded.next(true);
      },
      (err: HttpErrorResponse) => {
       
        //this.toast.error('There was an error fetching your user settings.', 'User Settings Error', {disableTimeOut: true});
      },
    );
  }

  public SaveUserSetting(setting: UserSetting, showToast = true): number {
    let returnId: number;
    this.http.post(environment.baseURl + `/api/user/settings/save`, setting).subscribe((rslt: number) => {

        if (showToast) {
          this.toast.success(`Your settings for ${setting.settingName} have been updated.`, 'User Settings Saved');
        }
        returnId = rslt;
      },
      (err: any) => {
       
        this.toast.error(`There was an error saving your user settings for ${setting.settingName}.`, 'User Settings Error', {disableTimeOut: true});
        returnId = 0;
      }
    );
    return returnId;
  }

  public DeleteUserSetting(setting: UserSetting) {

    this.http.post(environment.baseURl + `/api/user/settings/delete`, setting).subscribe((rslt: boolean) => {
        this.toast.success(`Cleared ${setting.settingName} setting.`, 'User Settings Deleted');
      },
      (err: any) => {
      
        this.toast.error(`There was an error deleting your ${setting.settingName} setting.`, 'User Settings Error', {disableTimeOut: true});
      }
    );
  }
}
